module.exports = __webpack_public_path__ + "assets/RetinaNarr-Medium.35400f5ba694a0ae4067708428f1b657.woff";